import * as types from './types';

const changeInbox = state => ({
  type: types.CHANGE_INBOX,
  payload: state
});

const fetchUnRead = params => ({
  type: types.FETCH_UNREAD,
  payload: params
});

const fetchUnReadSucceeded = data => ({
  type: types.FETCH_UNREAD_SUCCEEDED,
  payload: data.unread
});

export { changeInbox, fetchUnRead, fetchUnReadSucceeded };
